import { computed } from "vue";

export const useFiltering = (resources, searchQuery, comparisonFieldPath = "id", reverseList = false) => {

  const filteredResources = computed(() => {
    if (!searchQuery.value) return resources.value;
    const query = searchQuery.value.toLowerCase();
    return resources.value.filter(c =>
      c.attributes.searchString.toLowerCase().includes(query)
    );
  });

  const sortedResources = computed(() => {
    const sorted = [...filteredResources.value].sort((a, b) =>
      getNestedValue(a, comparisonFieldPath).localeCompare(getNestedValue(b, comparisonFieldPath))
    );

    return reverseList ? sorted.reverse() : sorted;
  });

  const getNestedValue = (obj, path)  => {
    return path.split(".").reduce((acc, key) => acc && acc[key], obj);
  };

  return {
    filteredResources,
    sortedResources
  };
};
